/**
 *Created by jmmartinez on 30/09/20
 * v.2.1  06/10/2020 Añadidos CELLTIPOEDITORS.
 * V.2.2  20/10/2020 Añadido CELLTIPO_ICONO
 * v.2.3  22/11/2020 Añadido CELLTIPO_ESTADOROW
 * v.2.3  03/12/2020 Añadido CELLTIPO_CADENA_CENTRO;
 * v.2.4  30/04/2021 Añadido CELLTIPO_ICONOACCION_IMPRIMIR
 * v.2.5  30/06/2021 Añadido CELLTIPO_IBAN
 *
 * v.2.6  06/05/2022 Union Planifikator y Sidemur
 * v.2.7  08/06/2022 Añadido CELLTIPO_PERSONALIZADO
 * v.2.8  07/07/2022 Añadido CELLTIPO_CADENACENTRO_ACCIONCONDICIONVALOR
 * v.2.9  27/01/2023 Añadido CELLTIPO_ENTERO_CENTRO,
 * v.2.10 24/04/2023 Añadido CELLTIPO_MODIFICARROW
 * v.2.11 25/04/2023 Añadido CELLTIPO_ELIMINARROW
 * v.2.12 18/07/2023 Añadido CELLTIPO_HORA
 * */


export const CELLTIPO_CADENA = 'CELLTIPO_CADENA';

export const CELLTIPO_MEMO = 'CELLTIPO_MEMO';

export const CELLTIPO_CADENA_CENTRO = 'CELLTIPO_CADENA_CENTRO';
export const CELLTIPO_FECHA = 'CELLTIPO_FECHA';
export const CELLTIPO_FECHA_IZQUIERDA = 'CELLTIPO_FECHA_IZQUIERDA';
export const CELLTIPO_FECHAHORA = 'CELLTIPO_FECHAHORA';
export const CELLTIPO_HORA = 'CELLTIPO_HORA';
export const CELLTIPO_MONEDA = 'CELLTIPO_MONEDA';
export const CELLTIPO_PORCENTAJE = 'CELLTIPO_PORCENTAJE';
export const CELLTIPO_CANTIDAD = 'CELLTIPO_CANTIDAD';
export const CELLTIPO_ENTERO = 'CELLTIPO_ENTERO';
export const CELLTIPO_ENTERO_CENTRO = 'CELLTIPO_ENTERO_CENTRO';
export const CELLTIPO_FLOTANTE = 'CELLTIPO_FLOTANTE';
export const CELLTIPO_SINO = 'CELLTIPO_SINO';
export const CELLTIPO_LISTA = 'CELLTIPO_LISTA';
export const CELLTIPO_BOTON = 'CELLTIPO_BOTON';
export const CELLTIPO_CHORA = 'CELLTIPO_CHORA';
export const CELLTIPO_IMAGENLISTA= 'CELLTIPO_IMAGENLISTA';
export const CELLTIPO_COLOR = 'CELLTIPO_COLOR';
export const CELLTIPO_COMBO = 'CELLTIPO_COMBO';
export const CELLTIPO_ICONO = 'CELLTIPO_ICONO';
export const CELLTIPO_ESTADOROW = 'CELLTIPO_ESTADOROW';
export const CELLTIPO_ICONOACCIONCONDICIONVALOR= 'CELLTIPO_ICONOACCIONCONDICIONVALOR';
export const CELLTIPO_IBAN = 'CELLTIPO_IBAN';
export const CELLTIPO_PERSONALIZADO= 'CELLTIPO_PERSONALIZADO';
export const CELLTIPO_FOREIGN= 'CELLTIPO_FOREIGN';
export const CELLTIPO_CADENAFOREIGN= 'CELLTIPO_CADENAFOREIGN';
export const CELLTIPO_CADENA_COLORES= 'CELLTIPO_CADENA_COLORES';

export const CELLTIPO_CADENACENTRO_ACCIONCONDICIONVALOR= 'CELLTIPO_CADENACENTRO_ACCIONCONDICIONVALOR';

export const CELLTIPO_ICONOACCION = 'CELLTIPO_ICONOACCION';
export const CELLTIPO_ICONOACCION_ELIMINAR = 'CELLTIPO_ICONOACCION_ELIMINAR';
export const CELLTIPO_ICONOACCION_DESCARGAR= 'CELLTIPO_ICONOACCION_DESCARGAR';
export const CELLTIPO_ICONOACCION_VER= 'CELLTIPO_ICONOACCION_VER';
export const CELLTIPO_ICONOACCION_IMPRIMIR= 'CELLTIPO_ICONOACCION_IMPRIMIR';

export const COLUMNVISIBLE_VARIABLE= 'COLUMNVISIBLE_VARIABLE';
export const COLUMNVISIBLE_SIEMPRE= 'COLUMNVISIBLE_SIEMPRE';
export const COLUMNVISIBLE_NUNCA= 'COLUMNVISIBLE_NUNCA';


export const CELLTIPOEDITOR_TEXTO = 'CELLTIPOEDITOR_TEXTO';
export const CELLTIPOEDITOR_COMBO = 'CELLTIPOEDITOR_COMBO';
export const CELLTIPOEDITOR_SELECTOR = 'CELLTIPOEDITOR_SELECTOR';
export const CELLTIPOEDITOR_COLOR = 'CELLTIPOEDITOR_COLOR';

export const CELLTIPO_MODIFICARROW = 'CELLTIPO_MODIFICARROW';
export const CELLTIPO_ELIMINARROW = 'CELLTIPO_ELIMINARROW';

export const CELLTIPO_COMPONENTES= 'CELLTIPO_COMPONENTES';

export const CELLTIPO_HTML = 'CELLTIPO_HTML';